/* @flow */

/*
  NavLink + Button component.
*/

import React from "react";
import styles from "./styles.scss";
import cn from "classnames";
import { NavLink } from "react-router-dom";
import { useTranslate } from "@awardit/react-use-translate";

import PlusIcon from "icons/plus.svg";
import MinusIcon from "icons/minus.svg";

type Props = {
  level: number,
  isFirst: boolean,
  hasButton: boolean,
  open: boolean,
  onClick?: () => void,
  toggle?: () => void,
  url: string,
  name?: string,
  children: React$Node,
};

const getLinkClassNames = (level: number, isFirst: boolean) =>
  cn({
    [styles.clickable]: true,
    [styles.clickableTwo]: level === 2,
    [styles.clickableThree]: level >= 3,
    [styles.clickableFirst]: isFirst,
  });

const NavToggle = (props: Props): React$Node => {
  const {
    level,
    isFirst,
    hasButton,
    open,
    onClick,
    toggle,
    url,
    children,
    name,
  } = props;
  const t = useTranslate();

  return (
    <div className={cn({ [styles.inset]: props.hasButton })}>
      <NavLink
        to={{
          pathname: url,
        }}
        activeClassName={styles.isActive}
        className={styles.link + " " + getLinkClassNames(level, isFirst)}
        onClick={onClick}
      >
        {children}
      </NavLink>

      {hasButton &&
        <button
          type="button"
          aria-label={open ? t("DRAWER.CLOSE_SUBMENU") : t("DRAWER.OPEN_SUBMENU")}
          aria-expanded={open}
          aria-controls={(name ? name : "") + "_children"}
          className={cn(
            getLinkClassNames(level, isFirst),
            styles.button
          )}
          onClick={toggle}
        >

          {open ?
            <MinusIcon aria-label={t("ICONS.MINUS")} className={styles.icon} /> :
            <PlusIcon aria-label={t("ICONS.PLUS")} className={styles.icon} />
          }
        </button>
      }
    </div>
  );
};

export default NavToggle;
